import { render, staticRenderFns } from "./ExamStatus.vue?vue&type=template&id=4b353260&"
import script from "./ExamStatus.vue?vue&type=script&lang=js&"
export * from "./ExamStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/ExamStatus.vue"
export default component.exports